interface PharmacotherapyMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}
const PharmacotherapyMenu: React.FC<PharmacotherapyMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={33}
            checked={!clear && displayValue === 33}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Beta blockers (BB)
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={34}
            checked={!clear && displayValue === 34}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Calcium channel blockers (CCB)
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={35}
            checked={!clear && displayValue === 35}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">BB + CCB</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={36}
            checked={!clear && displayValue === 36}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Disopyramide</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={37}
            checked={!clear && displayValue === 37}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Cardiac Myosin Inhibitors (CMI)
          </span>
        </label>
      </li>
    </ul>
  );
};

export default PharmacotherapyMenu;
